import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminGridComponent, GridColumn } from 'src/app/components/layout/admin-grid/admin-grid.component';
import { UserService, UserRole } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-manager',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminGridComponent],
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.scss']
})
export class UserManagerComponent implements OnInit {
  user = {
    picture: '/assets/images/avatar.png',
    nickname: 'Admin',
    email: 'admin@bouncd.com'
  };

  users: UserRole[] = [];
  loading = true;
  error: string | null = null;

  // Invite modal fields
  showInviteModal = false;
  inviteName = '';
  inviteEmail = '';
  inviteRole: 'admin' | 'client' = 'client';
  accountId = 'default-account-id'; // this should come from the selected account context

  columns: GridColumn[] = [
    { field: 'name', header: 'Name', sortable: true },
    { field: 'email', header: 'Email', sortable: true },
    { field: 'role', header: 'Role', sortable: true },
  ];

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.refreshUsers();
  }

  refreshUsers(): void {
    this.loading = true;
    this.error = null;

    this.userService.getAllUsers().subscribe({
      next: (users) => {
        this.users = users;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.message || 'Unable to fetch users.';
        this.loading = false;
      }
    });
  }

  get adminCount(): number {
    return this.users.filter(u => u.role === 'admin').length;
  }

  get clientCount(): number {
    return this.users.filter(u => u.role === 'client').length;
  }

  addUser(): void {
    this.showInviteModal = true;
  }

  sendInvite(): void {
    if (!this.inviteEmail.trim()) {
      alert('Please enter an email address.');
      return;
    }

    const payload = {
      accountId: this.accountId,
      email: this.inviteEmail.trim(),
      name: this.inviteName.trim(),
      role: this.inviteRole,
      inviter: this.user.email
    };

    this.loading = true;

    this.userService.inviteUser(payload).subscribe({
      next: (res) => {
        alert(`Invitation ${res?.message || 'sent'} to ${this.inviteEmail}`);
        this.showInviteModal = false;
        this.inviteName = '';
        this.inviteEmail = '';
        this.loading = false;
        this.refreshUsers();
      },
      error: (err) => {
        console.error('Invite failed:', err);
        alert(err.message || 'Failed to send invite.');
        this.loading = false;
      }
    });
  }

  cancelInvite(): void {
    this.showInviteModal = false;
    this.inviteName = '';
    this.inviteEmail = '';
  }

  editRole(row: UserRole): void {
    console.log('Edit user role', row);
  }

  deleteUser(row: UserRole): void {
    console.log('Delete user', row);
  }
}
